module.exports = __webpack_public_path__ + "static/img/2(2).f56790e5.jpg";